import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "items", "select", "addSection", "addButton", "item"]
  static values = { typeLabels: Object, editPath: String }

  itemTargetConnected() {
    this.wrapperTarget.classList.remove("hidden")
  }

  itemTargetDisconnected() {
    if (this.itemTargets.length === 0) {
      this.wrapperTarget.classList.add("hidden")
    }
  }

  showAddSection() {
    this.addSectionTarget.classList.remove("hidden")
    this.addButtonTarget.classList.add("hidden")
  }

  addQuestion() {
    const select = this.selectTarget
    const option = select.selectedOptions[0]
    if (!option || !option.value) return

    const questionId = option.value
    const questionText = option.dataset.questionText
    const questionType = option.dataset.questionType

    const itemHtml = this._buildQuestionItem(questionId, questionText, questionType)
    this.itemsTarget.insertAdjacentHTML("beforeend", itemHtml)

    option.remove()
    select.value = ""
  }

  removeQuestion(event) {
    const item = event.target.closest("[data-manage--form-questions-target='item']")
    if (item) item.remove()
  }

  _buildQuestionItem(id, text, type) {
    const labels = this.typeLabelsValue || {}
    const typeLabel = labels[type] || type

    return `
      <div id="question_item_${id}" data-manage--form-questions-target="item" data-question-id="${id}">
        <input type="hidden" name="manage_admin_contact_list_config_form[question_ids][]" value="${id}">
        <div class="w-full block text-left rounded-[6px] mb-[5px] outline-hidden transition-all duration-200 ease-linear active:scale-[0.995] text-black bg-[#f8f8f8] hover:bg-[#f2f2f2] py-[10px] px-[15px]">
          <div class="flex w-full items-center">
            <div class="flex items-center flex-1 min-w-0">
              <div class="flex-1 grid gap-[2px] min-w-0">
                <span class="block font-normal leading-[1.3] text-[16px]">
                  <span class="flex items-center">
                    <span class="grow pr-[20px]">${this._escapeHtml(text)}</span>
                    <span class="inline-flex items-center rounded-full px-[8px] py-[2px] text-[11px] font-medium bg-[#e6f9e7] text-[#1a7a1e]">${this._escapeHtml(typeLabel)}</span>
                  </span>
                </span>
              </div>
            </div>
            <div class="pl-[15px] shrink-0">
              <a href="${this.editPathValue.replace('__ID__', id)}" data-turbo-frame="modal"
                class="inline-flex items-center justify-center w-[30px] h-[30px] rounded-[8px] border border-[#dfdfdf] text-[13px] hover:bg-[#f5f5f5]">
                <i class="fa-regular fa-pen-to-square text-[12px]"></i>
              </a>
              <button type="button"
                class="inline-flex items-center justify-center w-[30px] h-[30px] rounded-[8px] border border-[#dfdfdf] text-[13px] hover:bg-[#f5f5f5]"
                data-action="manage--form-questions#removeQuestion">
                <i class="fa-solid fa-trash text-[12px]"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    `
  }

  _escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
